//
//
//
//
//
//
//
//
//
//

import { DatePicker } from 'element-ui'
import { isBefore } from 'date-fns'

export default {
  components: {
    ElDatePicker: DatePicker,
  },
  inheritAttrs: false,
  props: {
    minYear: {
      type: Number,
      default: 2014,
    },
  },
  data() {
    return {
      cKey: `${Math.random().toString(36).slice(2, 9)}`,
      panelTitle: '',
    }
  },
  computed: {
    popperClass() {
      return `date-picker-popper-${this.cKey}`
    },
    listeners() {
      return {
        ...this.$listeners,
        focus: this.handleFocus,
        blur: this.handleBlur,
      }
    },
    pickerOptions() {
      const propsPickerOptions = this.$attrs['picker-options'] || {}

      return Object.assign({}, propsPickerOptions, {
        disabledDate: (time) => {
          const checkMinYearResult = isBefore(
            time,
            new Date(this.minYear, 0, 1)
          )

          // Check if the disabledDate function is provided in props, use it if available
          const checkAttrDisabledDateResult = propsPickerOptions.disabledDate
            ? propsPickerOptions.disabledDate(time)
            : false

          return checkMinYearResult || checkAttrDisabledDateResult
        },
      })
    },
    isDisabledPrevYear() {
      return !!(this.panelDate.year && this.panelDate.year <= this.minYear)
    },
    isDisabledPrevMonth() {
      return this.panelDate.year === this.minYear && this.panelDate.month === 1
    },
    panelDate() {
      const [year, month] = this.panelTitle
        .split('年')
        .map((item) => (item ? parseInt(item) : null))

      return {
        year,
        month: month || null,
      }
    },
  },
  mounted() {
    this.instance = this.$refs.datePicker
  },
  methods: {
    handleFocus() {
      if (this.$listeners.focus) {
        this.$listeners.focus(this.instance)
      }

      this.$nextTick(() => {
        this.$pickerPopper = document.querySelector(`.${this.popperClass}`)

        if (!this.$pickerPopper || this.pickerPopperEvent) {
          return
        }

        this.$pickerPopper.classList.add('date-picker-popper-active')

        // Initial render
        this.renderPopper()

        this.pickerPopperEvent = (e) => {
          const prevYearBtn = this.$pickerPopper.querySelector(
            '.el-date-picker__prev-btn[aria-label="前年"]'
          )
          const nextYearBtn = this.$pickerPopper.querySelector(
            '.el-date-picker__next-btn[aria-label="翌年"]'
          )
          const prevMonthBtn = this.$pickerPopper.querySelector(
            '.el-date-picker__prev-btn[aria-label="前月"]'
          )
          const nextMonthBtn = this.$pickerPopper.querySelector(
            '.el-date-picker__next-btn[aria-label="翌月"]'
          )

          const navButtons = [
            prevYearBtn,
            nextYearBtn,
            prevMonthBtn,
            nextMonthBtn,
          ].filter(Boolean)

          if (
            !navButtons.some(
              (btn) => e.target === btn || btn.contains(e.target)
            )
          ) {
            return
          }

          this.renderPopper()
        }

        this.$pickerPopper.addEventListener('click', this.pickerPopperEvent)
      })
    },
    handleBlur() {
      if (this.$listeners.blur) {
        this.$listeners.blur(this.instance)
      }

      if (this.pickerPopperEvent && this.$pickerPopper) {
        this.$pickerPopper.classList.remove('date-picker-popper-active')
        this.$pickerPopper.removeEventListener('click', this.pickerPopperEvent)

        this.pickerPopperEvent = null
      }
    },
    renderPopper() {
      if (!this.$pickerPopper) {
        return
      }

      this.panelTitle = this.$pickerPopper.querySelector(
        '.el-date-picker__header'
      ).innerText

      this.$pickerPopper.classList.toggle(
        'is-disabled-prev-year',
        this.isDisabledPrevYear
      )

      this.$pickerPopper.classList.toggle(
        'is-disabled-prev-month',
        this.isDisabledPrevMonth
      )
    },
  },
}
